import { backendURL, postRestURL } from "../utils/constants/constants";

export async function postProduct({ body, token }) {
    try {
        const response = await fetch(`${backendURL}/product/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function putProduct({ productId, body, token }) {
    try {
        const response = await fetch(`${backendURL}/product/${productId}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getCompanyData({ userName }) {
    try {
        const response = await fetch(`${backendURL}/company/${userName}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function deleteProduct({ productId, productBody, token }) {

    try {
        const response = await fetch(`${backendURL}/product/${productId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(productBody)

        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}


export async function getAllCompanies({ limit, offset, query }) {
    try {
        const response = await fetch(`${postRestURL}/companypublic?limit=${limit}&offset=${offset}${query}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN,
                'Prefer': 'count=exact'
            }
        });
        const pagination = response.headers.get('Content-Range');
        const data = await response.json();
        return { data, pagination };
    } catch (e) {
        throw (e);
    }
}

export async function deleteCompanyAccount({ token }) {
    try {
        const response = await fetch(`${backendURL}/company`, {
            method: 'DELETE',
            headers: {
                'Accept': '*/*',
                'Authorization': token
            }
        });
        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}

export async function postLikeToInfluencers({ likeBody }) {
    try {
        const response = await fetch(`${postRestURL}/likeinfluincr`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            },
            body: JSON.stringify(likeBody)
        });
        return response;
    } catch (e) {
        throw (e);
    }
}

export async function deleteLikeToInfluencers({ companyId, influencerId }) {
    try {
        const response = await fetch(`${postRestURL}/likeinfluincr?companyidlike=eq.${companyId}&influincridlike=eq.${influencerId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        return response;
    } catch (e) {
        throw (e);
    }
}

export async function getInfluencerLikeFromCompany({ companyId }) {
    try {
        const response = await fetch(`${postRestURL}/likeinfluincr?select=*&companyidlike=eq.${companyId}`, {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + process.env.REACT_APP_POSTREST_TOKEN
            }
        });

        const data = await response.json();
        return data;
    } catch (e) {
        throw (e);
    }
}